import './domain-tree.component.ajscss';

import { IHypervisionService } from '@hypervision/hypervision.service';
import { Domain } from '@hypervision/models/domain';
import { IChangesObject, IComponentController, IComponentOptions, isDefined, isObject, isUndefined } from 'angular';

import { Option } from '@contact/upgrade';

import templateUrl from './domain-tree.component.ajs.html';

class DomainTreeCtrl implements IComponentController {
  public domain: Domain;
  public selectedDomainUuids: string[];
  public selectedIndicator: any = undefined;
  public showAggregated: boolean = false;
  public onSelectDomain: Function;

  public isDeployed = false;

  constructor(private readonly hypervision: IHypervisionService) {}

  $onInit() {}

  $onChanges(onChangesObj: { [property: string]: IChangesObject }) {
    if (onChangesObj['selectedDomainUuids'] && isDefined(onChangesObj['selectedDomainUuids'].currentValue)) {
      this.selectedDomainUuids = onChangesObj['selectedDomainUuids'].currentValue;
    }
    if (onChangesObj['selectedIndicator'] && isDefined(onChangesObj['selectedIndicator'].currentValue)) {
      this.selectedIndicator = onChangesObj['selectedIndicator'].currentValue;
    }
    if (onChangesObj['showAggregated'] && isDefined(onChangesObj['showAggregated'].currentValue)) {
      this.showAggregated = onChangesObj['showAggregated'].currentValue;
    }
  }

  indicatorColorValue() {
    if (isObject(this.selectedIndicator) && isObject(this.domain)) {
      let indicator = this.selectedIndicator;
      let metrics = this.domain.metrics;
      if (this.showAggregated || this.hypervision.isRoot(this.domain)) {
        metrics = this.domain.aggregatedMetrics;
      }
      return indicator.color(this.domain, metrics);
    }
    return 0;
  }

  formattedIndicatorValue() {
    if (isObject(this.selectedIndicator) && isObject(this.domain)) {
      let indicator = this.selectedIndicator;
      let metrics = this.domain.metrics;
      if (this.showAggregated || this.hypervision.isRoot(this.domain)) {
        metrics = this.domain.aggregatedMetrics;
      }
      return indicator.format(indicator.value(this.domain, metrics));
    }
    return '';
  }

  isSelectDomain(domain: Domain): boolean {
    if (isUndefined(domain)) return false;
    return Option.of(this.selectedDomainUuids)
      .map(uuids => uuids.indexOf(domain.uuid) >= 0)
      .getOrElse(false);
  }

  _onSelectDomain(domain: Domain) {
    // Update currentDomain
    this.onSelectDomain({ $event: { selectedDomain: domain } });
  }

  onNextSelectDomain({ selectedDomain }) {
    if (isUndefined(selectedDomain)) return;
    this._onSelectDomain(selectedDomain);
  }
}

export class DomainTree implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    domain: '<',
    selectedDomainUuids: '<',
    selectedIndicator: '<',
    showAggregated: '<',
    onSelectDomain: '&',
  };
  controller = ['hypervision', DomainTreeCtrl];
}

export default 'domainTree';
